export const cock_get="cocktail/get";

export const single_cock="singlecocktail/get";

export const delete_cock="cocktail/delete";